import api from "../api";
import DateIT from "./DateIT";
import Autocomplete from "./Autocomplete";
import { Modal } from "./ui";

// Modale crea/modifica impegno (clienti, lead, studio, personale, blocco)
export function ApptModal({ form, setForm, companies, setCompanies, leads, gcalConnected, editId, contact, onSave, onDelete, onCancel }) {
  return (
    <Modal title={editId ? "Modifica impegno" : "Nuovo impegno"} onClose={onCancel}>
      {editId && contact && (contact.phone || contact.email || contact.lead_id) && (
        <div data-testid="appt-contact-box" style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center",
          padding: "10px 12px", marginBottom: 14, borderRadius: 10,
          background: "rgba(56,189,248,.08)", border: "1px solid rgba(56,189,248,.25)" }}>
          <span className="muted" style={{ fontSize: 12 }}>📇 Prenotante:</span>
          {contact.phone && (
            <a className="btn" href={`tel:${contact.phone}`} data-testid="appt-contact-phone">📞 {contact.phone}</a>
          )}
          {contact.email && (
            <a className="btn" href={`mailto:${contact.email}`} data-testid="appt-contact-email">✉️ {contact.email}</a>
          )}
          {contact.lead_id && (
            <a className="btn" href={`/lead/${contact.lead_id}`} data-testid="appt-contact-lead">🔁 Scheda lead{contact.lead_name ? ` · ${contact.lead_name}` : ""}</a>
          )}
        </div>
      )}
      <div className="field"><label>Tipo di impegno</label>
        <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="appt-kind">
          <option value="cliente">Appuntamento con cliente</option>
          <option value="lead">Incontro con Lead</option>
          <option value="studio">Lavoro di studio (interno)</option>
          <option value="personale">Personale</option>
          <option value="blocco">Periodo / chiusura (corso, ferie…)</option>
        </select>
      </div>

      {form.category === "blocco" ? (
        <>
          <div className="field"><label>Descrizione *</label>
            <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="es. Ferie, Corso aggiornamento" data-testid="block-title" />
          </div>
          <div className="grid-2">
            <div className="field"><label>Dal giorno</label><DateIT value={form.date} onChange={(v) => setForm({ ...form, date: v })} data-testid="block-start" /></div>
            <div className="field"><label>Al giorno</label><DateIT value={form.end_date} onChange={(v) => setForm({ ...form, end_date: v })} data-testid="block-end" /></div>
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
            <input type="checkbox" checked={form.all_day} onChange={(e) => setForm({ ...form, all_day: e.target.checked })} data-testid="block-allday" />
            <span>Tutto il giorno</span>
          </label>
          {!form.all_day && (
            <div className="grid-2">
              <div className="field"><label>Ora inizio</label><input type="time" value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} /></div>
              <div className="field"><label>Durata (minuti)</label><input type="number" min="5" step="5" value={form.dur} onChange={(e) => setForm({ ...form, dur: e.target.value })} /></div>
            </div>
          )}
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
            <input type="checkbox" checked={form.blocks_booking} onChange={(e) => setForm({ ...form, blocks_booking: e.target.checked })} data-testid="block-blocks-booking" />
            <span>Impedisci ai clienti di prenotare in questi giorni</span>
          </label>
        </>
      ) : (
        <>
          {(form.category === "cliente" || form.category === "studio") && (
            <div className="field"><label>Cliente {form.category === "cliente" ? "*" : "(facoltativo)"}</label>
              <Autocomplete testid="appt-company-ac"
                items={companies.map((c) => ({ id: c.id, label: c.name }))}
                initialText={companies.find((c) => c.id === form.company_id)?.name || form.company || ""}
                placeholder="Scrivi il nome del cliente…"
                createLabel="Crea cliente"
                onSelect={(it) => setForm((f) => ({ ...f, company_id: it.id, company: it.label }))}
                onCreate={async (txt) => {
                  try {
                    const r = await api.post("/companies", { name: txt });
                    setCompanies((prev) => [...prev, r.data].sort((a, b) => a.name.localeCompare(b.name)));
                    setForm((f) => ({ ...f, company_id: r.data.id, company: r.data.name }));
                  } catch (e) { alert("Errore creazione cliente: " + (e?.response?.data?.detail || e.message)); }
                }} />
            </div>
          )}
          {(form.category === "cliente" || form.category === "studio") && (
            <div className="field">
              <label>Con chi è l'appuntamento (facoltativo — è ciò che vedrai in calendario)</label>
              <input value={form.with_who} onChange={(e) => setForm({ ...form, with_who: e.target.value })}
                placeholder="es. Dott. Rossi (commercialista), Notaio Bianchi…" data-testid="appt-with-who" />
              {form.with_who.trim() && form.company_id && (
                <p className="muted" style={{ fontSize: 12, margin: "4px 0 0" }}>In calendario vedrai "{form.with_who.trim()}"; le ore restano conteggiate sul cliente abbinato.</p>
              )}
            </div>
          )}
          {form.category === "lead" && (
            <>
              <div className="field"><label>Lead *</label>
                <Autocomplete testid="appt-lead-ac"
                  items={leads.map((p) => ({ id: p.id, label: `${p.first_name} ${p.last_name}`.trim(), sub: p.email }))}
                  initialText={form.lead_new ? `${form.lead_first} ${form.lead_last}`.trim() : (() => { const s = leads.find((p) => p.id === form.person_id); return s ? `${s.first_name} ${s.last_name}`.trim() : ""; })()}
                  placeholder="Scrivi il nome del lead…"
                  createLabel="Nuova anagrafica"
                  onSelect={(it) => setForm((f) => ({ ...f, person_id: it.id, lead_new: false }))}
                  onCreate={(txt) => { const p = txt.split(" "); setForm((f) => ({ ...f, lead_new: true, person_id: "", lead_first: p[0] || txt, lead_last: p.slice(1).join(" ") })); }} />
              </div>
              {form.lead_new && (
                <div className="grid-2" data-testid="appt-lead-new">
                  <div className="field"><label>Nome *</label><input value={form.lead_first} onChange={(e) => setForm({ ...form, lead_first: e.target.value })} data-testid="lead-first" /></div>
                  <div className="field"><label>Cognome *</label><input value={form.lead_last} onChange={(e) => setForm({ ...form, lead_last: e.target.value })} data-testid="lead-last" /></div>
                  <div className="field"><label>Email</label><input value={form.lead_email} onChange={(e) => setForm({ ...form, lead_email: e.target.value })} data-testid="lead-email" /></div>
                  <div className="field"><label>Telefono</label><input value={form.lead_phone} onChange={(e) => setForm({ ...form, lead_phone: e.target.value })} data-testid="lead-phone" /></div>
                </div>
              )}
            </>
          )}
          {(form.category === "cliente" || form.category === "studio" || form.category === "lead") && (
            <div className="field" data-testid="appt-participants">
              <label>Altri partecipanti all'incontro (facoltativo)</label>
              {(form.participants || []).map((p, i) => (
                <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }} data-testid={`appt-participant-${i}`}>
                  <input style={{ flex: 1.2 }} placeholder="Nome e cognome" value={p.name || ""}
                    onChange={(e) => setForm({ ...form, participants: form.participants.map((x, j) => j === i ? { ...x, name: e.target.value } : x) })}
                    data-testid={`participant-name-${i}`} />
                  <input style={{ flex: 1.4 }} placeholder="Email" value={p.email || ""}
                    onChange={(e) => setForm({ ...form, participants: form.participants.map((x, j) => j === i ? { ...x, email: e.target.value } : x) })}
                    data-testid={`participant-email-${i}`} />
                  <input style={{ flex: 1 }} placeholder="Cellulare" value={p.phone || ""}
                    onChange={(e) => setForm({ ...form, participants: form.participants.map((x, j) => j === i ? { ...x, phone: e.target.value } : x) })}
                    data-testid={`participant-phone-${i}`} />
                  <button type="button" className="btn sm danger" onClick={() => setForm({ ...form, participants: form.participants.filter((_, j) => j !== i) })} data-testid={`participant-remove-${i}`}>✕</button>
                </div>
              ))}
              <button type="button" className="btn sm" onClick={() => setForm({ ...form, participants: [...(form.participants || []), { name: "", email: "", phone: "" }] })} data-testid="participant-add">＋ Aggiungi partecipante</button>
              <p className="muted" style={{ fontSize: 12, margin: "4px 0 0" }}>A fine incontro il questionario di gradimento arriva anche a ciascun partecipante (via SMS se c'è il cellulare, altrimenti via email).</p>
            </div>
          )}
          {(form.category === "cliente" || form.category === "lead") && (
            <div className="field"><label>Tipologia</label>
              <select value={form.mode} onChange={(e) => setForm({ ...form, mode: e.target.value })}>
                <option value="zoom">Videoriunione Zoom</option>
                <option value="presenza">Riunione in presenza</option>
                <option value="trasferta">Trasferta dal cliente</option>
                <option value="phone">Telefonata</option>
                <option value="studio">Lavoro di studio</option>
              </select>
            </div>
          )}
          <div className="grid-2">
            <div className="field"><label>Data</label><DateIT value={form.date} onChange={(v) => setForm({ ...form, date: v })} /></div>
            <div className="field"><label>Ora</label><input type="time" value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} /></div>
          </div>
          <div className="grid-2">
            <div className="field"><label>Durata (minuti)</label><input type="number" min="5" step="5" value={form.dur} onChange={(e) => setForm({ ...form, dur: e.target.value })} /></div>
            <div className="field"><label>{form.category === "personale" ? "Descrizione" : "Note (facoltative)"}</label><input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder={form.category === "personale" ? "es. Dentista" : ""} data-testid="appt-title" /></div>
          </div>
          {form.category === "personale" ? (
            <p className="muted">Gli impegni personali non vengono conteggiati nelle ore dei clienti.</p>
          ) : form.category === "lead" ? (
            <p className="muted">Gli incontri con i lead non vengono conteggiati nelle ore dei clienti.</p>
          ) : (
            <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }} data-testid="count-hours-label">
              <input type="checkbox" checked={form.count_hours} onChange={(e) => setForm({ ...form, count_hours: e.target.checked })} data-testid="count-hours-checkbox" />
              <span>Conteggia queste ore nel margine del cliente {form.category === "studio" && !form.company_id ? "(serve un cliente abbinato)" : ""}</span>
            </label>
          )}
          {(form.category === "cliente" || form.category === "lead") && (
            <div style={{ marginTop: 8, borderTop: "1px solid var(--border)", paddingTop: 10 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8 }} data-testid="sms-reminder-label">
                <input
                  type="checkbox"
                  checked={form.send_sms_reminder}
                  onChange={(e) => {
                    const on = e.target.checked;
                    let ph = form.sms_phone;
                    if (on && !ph) {
                      if (form.category === "cliente") {
                        ph = companies.find((c) => c.id === form.company_id)?.phone || "";
                      } else if (form.lead_new) {
                        ph = form.lead_phone || "";
                      } else {
                        ph = leads.find((p) => p.id === form.person_id)?.phone || "";
                      }
                    }
                    setForm({ ...form, send_sms_reminder: on, sms_phone: ph });
                  }}
                  data-testid="sms-reminder-checkbox"
                />
                <span>📲 Invia promemoria SMS al cliente <span className="muted">(conferma il giorno prima + promemoria 1h prima)</span></span>
              </label>
              {form.send_sms_reminder && (
                <div className="field" style={{ marginTop: 8 }}>
                  <label>Numero di cellulare per l'SMS *</label>
                  <input
                    value={form.sms_phone}
                    onChange={(e) => setForm({ ...form, sms_phone: e.target.value })}
                    placeholder="es. 3331234567"
                    data-testid="sms-reminder-phone"
                  />
                  <p className="muted" style={{ fontSize: 12, marginTop: 4 }}>Verrà usato questo numero per gli SMS via SMShosting. Se lasci vuoto, il promemoria non partirà.</p>
                </div>
              )}
            </div>
          )}
          {gcalConnected && !editId && (
            <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }} data-testid="gcal-add-label">
              <input type="checkbox" checked={form.gcal} onChange={(e) => setForm({ ...form, gcal: e.target.checked })} data-testid="gcal-add-checkbox" />
              <span>Aggiungi anche a Google Calendar</span>
            </label>
          )}
        </>
      )}
      <div className="modal-actions">
        {editId && <button className="btn danger" onClick={onDelete} data-testid="appt-delete">Elimina</button>}
        <div className="spacer" />
        <button className="btn" onClick={onCancel}>Annulla</button>
        <button className="btn primary" onClick={onSave} data-testid="appt-save">{editId ? "Salva modifiche" : "Salva"}</button>
      </div>
    </Modal>
  );
}

// Modale evento iCloud (sola lettura)
export function IcloudEventModal({ icevent, onClose, onCreate }) {
  return (
    <Modal title="Evento iCloud" onClose={onClose}>
      <p className="muted" style={{ marginTop: 0 }}>Calendario: {icevent.calendar_name}{" · (sola lettura su iCloud)"}</p>
      <div className="field"><label>Titolo</label><input value={icevent.summary || ""} disabled data-testid="icevent-summary" /></div>
      <div className="grid-2">
        <div className="field"><label>Inizio</label><input value={(icevent.start || "").replace("T", " ").slice(0, 16)} disabled /></div>
        <div className="field"><label>Fine</label><input value={(icevent.end || "").replace("T", " ").slice(0, 16)} disabled /></div>
      </div>
      {icevent.location && <div className="field"><label>Luogo</label><input value={icevent.location} disabled /></div>}
      {icevent.description && <div className="field"><label>Descrizione</label><textarea rows={3} value={icevent.description} disabled /></div>}
      <p className="muted" style={{ fontSize: 12 }}>Per gestire questo evento nel CRM (abbinarlo a un cliente, conteggiare le ore, aggiungere note) crea un impegno collegato.</p>
      <div className="modal-actions">
        <button className="btn" onClick={onClose}>Chiudi</button>
        <button className="btn primary" onClick={() => onCreate(icevent)} data-testid="icevent-create-appt">Crea impegno nel CRM</button>
      </div>
    </Modal>
  );
}

// Modale controproposta a una richiesta di prenotazione
export function ProposalModal({ propose, propDate, setPropDate, propTime, setPropTime, onClose, onSend }) {
  return (
    <Modal title={`Controproposta a ${propose.name}`} onClose={onClose}>
      <div className="grid-2">
        <div className="field"><label>Nuova data</label><DateIT value={propDate} onChange={(v) => setPropDate(v)} /></div>
        <div className="field"><label>Nuova ora</label><input type="time" value={propTime} onChange={(e) => setPropTime(e.target.value)} /></div>
      </div>
      <p className="muted">Il cliente riceverà la controproposta e dovrà accettarla.</p>
      <div className="modal-actions">
        <button className="btn" onClick={onClose}>Annulla</button>
        <button className="btn primary" onClick={onSend}>Invia controproposta</button>
      </div>
    </Modal>
  );
}

// Modale evento Google Calendar (modifica/elimina se editable)
export function GoogleEventModal({ gevent, gform, setGform, onClose, onSave, onDelete, onImport }) {
  return (
    <Modal title="Evento Google Calendar" onClose={onClose}>
      {gevent.calendar_name && <p className="muted" style={{ marginTop: 0 }}>Calendario: {gevent.calendar_name}{!gevent.editable ? " · (sola lettura)" : ""}</p>}
      <div className="field"><label>Titolo</label><input value={gform.summary} onChange={(e) => setGform({ ...gform, summary: e.target.value })} disabled={!gevent.editable} data-testid="gevent-summary" /></div>
      <div className="grid-2">
        <div className="field"><label>Data</label><DateIT value={gform.date} onChange={(v) => setGform({ ...gform, date: v })} disabled={!gevent.editable || gevent.all_day} /></div>
        <div className="field"><label>Orario</label>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <input type="time" value={gform.start} onChange={(e) => setGform({ ...gform, start: e.target.value })} disabled={!gevent.editable || gevent.all_day} />
            <span className="muted">→</span>
            <input type="time" value={gform.end} onChange={(e) => setGform({ ...gform, end: e.target.value })} disabled={!gevent.editable || gevent.all_day} />
          </div>
        </div>
      </div>
      <div className="field"><label>Luogo</label><input value={gform.location} onChange={(e) => setGform({ ...gform, location: e.target.value })} disabled={!gevent.editable} /></div>
      <div className="field"><label>Descrizione</label><textarea rows={4} value={gform.description} onChange={(e) => setGform({ ...gform, description: e.target.value })} disabled={!gevent.editable} /></div>
      {gevent.html_link && <p className="muted"><a href={gevent.html_link} target="_blank" rel="noreferrer">Apri su Google Calendar ↗</a></p>}
      <div className="modal-actions">
        {gevent.editable && <button className="btn danger" onClick={onDelete} data-testid="gevent-delete">Elimina</button>}
        {onImport && <button className="btn" onClick={onImport} title="Crea un appuntamento CRM da questo evento: potrai collegare il cliente e attivare il promemoria SMS" data-testid="gevent-import-crm">📥 Importa nel CRM</button>}
        <div className="spacer" />
        <button className="btn" onClick={onClose}>Chiudi</button>
        {gevent.editable && <button className="btn primary" onClick={onSave} data-testid="gevent-save">Salva modifiche</button>}
      </div>
    </Modal>
  );
}
